import React, { useState } from "react";
import styles from "./ExpensesTab.module.css";

const emptyForm = { title: "", amount: "", expenseType: "", expenseDate: "", employeeId: "", notes: "" };

const ExpenseFormModal = ({ initialData, employees, expenseTypes, onSubmit, onClose }) => {
  const [form, setForm] = useState(
    initialData
      ? { ...initialData, expenseDate: initialData.expenseDate?.slice(0, 10), employeeId: initialData.employeeId || "" }
      : emptyForm
  );
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await onSubmit({
        ...form,
        amount: Number(form.amount),
        employeeId: form.employeeId ? Number(form.employeeId) : null,
        expenseDate: new Date(form.expenseDate).toISOString(),
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <form className={styles.modal} onClick={(e) => e.stopPropagation()} onSubmit={handleSubmit}>
        <h3>{initialData ? "تعديل مصروف" : "إضافة مصروف جديد"}</h3>

        <div className={styles.formGrid}>
          <label>العنوان
            <input name="title" value={form.title} onChange={handleChange} required />
          </label>
          <label>المبلغ
            <input type="number" name="amount" value={form.amount} onChange={handleChange} required min="0" />
          </label>
          <label>
            نوع المصروف
            <select
                name="expenseType"
                value={form.expenseType}
                onChange={handleChange}
                required
            >
                <option value="">اختر النوع</option>

                {expenseTypes.map((type) => (
                <option key={type.value} value={type.value}>
                    {type.label}
                </option>
                ))}
            </select>
            </label>
          <label>تاريخ المصروف
            <input type="date" name="expenseDate" value={form.expenseDate} onChange={handleChange} required />
          </label>
          <label>الموظف المرتبط (اختياري)
            <select name="employeeId" value={form.employeeId} onChange={handleChange}>
              <option value="">بدون</option>
              {employees.map((emp) => <option key={emp.id} value={emp.id}>{emp.fullName}</option>)}
            </select>
          </label>
          <label className={styles.fullWidth}>ملاحظات
            <textarea name="notes" value={form.notes} onChange={handleChange} rows={2} />
          </label>
        </div>

        <div className={styles.actions}>
          <button type="button" className={styles.cancelBtn} onClick={onClose} disabled={submitting}>إلغاء</button>
          <button type="submit" className={styles.confirmBtn} disabled={submitting}>
            {submitting ? "جاري الحفظ..." : "حفظ"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ExpenseFormModal;